<app-offcanvas-header header="{{isEdit ? 'Edit' : 'Add'}} Supporting Document Type"
(closeClicked)="onCloseIconClick(false)"></app-offcanvas-header>
<div class="offCanvas__container">
  <div class="offCanvas__contentWrapper">
    <form class="mt-2" [formGroup]="supportingDocumentTypeFormGroup">
      <div class="offcanvas__content">
        <div class="offcanvas__orgDetails">
          <div class="offCanvas__orgName-inputField">
            <app-input-filed label="Name" placeholder="Enter Name"
            [control]="$any(supportingDocumentTypeFormGroup).controls['name']" [starIcon]="'*'"></app-input-filed>
            @if (supportingDocumentTypeFormGroup.get('name')?.invalid &&
              (supportingDocumentTypeFormGroup.get('name')?.dirty ||
              supportingDocumentTypeFormGroup.get('name')?.touched)) {
              <div>
                @if (supportingDocumentTypeFormGroup.get('name')?.errors?.['required']) {
                  <div>
                    <small class="text-danger">Name is required.</small>
                  </div>
                }
              </div>
            }
          </div>
          <div class="offCanvas__orgName-inputField mt-3">
            <app-input-filed label="Description" placeholder="Enter Description"
            [control]="$any(supportingDocumentTypeFormGroup).controls['description']" [starIcon]="'*'"></app-input-filed>
            @if (supportingDocumentTypeFormGroup.get('description')?.invalid &&
              (supportingDocumentTypeFormGroup.get('description')?.dirty ||
              supportingDocumentTypeFormGroup.get('description')?.touched)) {
              <div>
                @if (supportingDocumentTypeFormGroup.get('description')?.errors?.['required']) {
                  <div>
                    <small class="text-danger">Description is required.</small>
                  </div>
                }
              </div>
            }
          </div>
          @if (errorMessage) {
            <p class="text-danger m-2">{{errorMessage}}</p>
          }
        </div>
      </div>
    </form>
  </div>
  <div class="offCanvas__footer">
    <app-common-button (clickEvent)="onCloseIconClick(false)" buttonClass="smallbutton"
    buttonLabel="Cancel"></app-common-button>
    @if (commonService.orgLock()) {
      <app-common-button (clickEvent)="onSubmit()" [loadingIcon]="verifyLoader" buttonClass="smallFilledButton"
        [buttonLabel]="isEdit ? 'Update' : 'Save'"
      [disabled]="supportingDocumentTypeFormGroup.invalid"></app-common-button>
    }
  </div>
</div>
